/**
 * Get the path of a route without the query parameters.
 *
 * @param path - Path that may include query parameters
 * @returns Route path
 */
export function getQuerylessPath(path: string) {
    return path.split("?")[0]
}
